import WrapperElementPropsType from "../../types/component/WrapperElementPropsType";

export default function ChapterTitle(props: WrapperElementPropsType) {
    return <h2 className={"text-lobcv-blue-600 text-xl font-bold mb-3 " + (props.className !== undefined ? props.className : '')}>{props.children}</h2>
}
